const routes = [
  {
    path: "/manutencao-excecao-objeto",
    name: "manutencao-excecao-objeto",
    meta: {
      allowedPermissions: ["excecao_objeto_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoExcecaoObjeto/ManutencaoExcecaoObjetoHome.vue"),
  },

  {
    path: "/manutencao-excecao-objeto/novo",
    name: "manutencao-excecao-objeto-novo",
    meta: {
      allowedPermissions: ["excecao_objeto_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoExcecaoObjeto/ManutencaoExcecaoObjetoCad.vue"),
  },

  {
    path: "/manutencao-excecao-objeto/editar/:id",
    name: "manutencao-excecao-objeto-editar",
    meta: {
      allowedPermissions: ["excecao_objeto_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoExcecaoObjeto/ManutencaoExcecaoObjetoEdit.vue"),
  },
];

export default routes;
